import { ReactNode, Children } from 'react';

export function useHeaderFooter(children: ReactNode): { headerContent: ReactNode, footerContent: ReactNode } {
  let headerContent: ReactNode = null;
  let footerContent: ReactNode = null;

  Children.forEach(children, (child, index) => {
    if (index === 0) {
      headerContent = child;
    } else {
      footerContent = child;
    }
  });

  return {
    headerContent,
    footerContent,
  };
}
